<template>
  <div class="form-data">
    <el-form ref="form" :label-position="labelPosition" :inline="isInline" :model="model" :rules="rules" :label-width="labelWidth">
      <div v-for="(row, i) in buildFields" :key="i" class="flex-row">
        <div v-for="(col, j) in row" :key="j" class="d-ib col">
          <el-form-item :label="col.label" :prop="col.name">
            <el-button class="link" v-if="col.linkText" type="text" @click="() => col.linkAction($dialog, model[ col.name ])">{{ col.linkText }}</el-button>
            <el-button class="link" v-if="col.copy && model[ col.name ]" type="text" v-clipboard:copy="model[ col.name ]" v-clipboard:success="() => $message.success('复制成功')">复制链接</el-button>
            <el-input v-if="col.elTag === 'el-input'" v-model="model[ col.name ]" @blur="event => col.onBlur && col.onBlur(self, event.target.value)" v-bind="{ ...col.elProps }" />
            <div v-if="col.elTag === 'el-radio-group'" class="radio-group">
              <el-radio-group v-model="model[ col.name ]" v-bind="{ ...col.elProps }" @change="val => col.onChange && col.onChange(self, val)">
                <el-radio v-for="el in col.children" :key="el.name" :label="el.value">{{ el.name }}</el-radio>
              </el-radio-group>
            </div>
            <ui-upload v-if="col.elTag == 'el-upload'" :value="model[ col.name ]" v-bind="col.elProps" @submit="file => col.onUrl(self, file)"></ui-upload>
            <div v-if="col.elTag === 'el-image'" class="t-a-center">
              <img :src="model[ col.name ]" width="120px" height="120px" style="object-fit: cover; margin-bottom: 14px" />
              <div style="line-height: 1">
                <el-button type="text" @click="() => col.imgAction(model[ col.name ])">{{ col.imgText }}</el-button>
              </div>
            </div>
            <el-date-picker v-if="col.elTag === 'el-date-picker'" v-model="model[ col.name ]" v-bind="{ ...col.elProps }"></el-date-picker>
            <el-select v-if="col.elTag === 'el-select'" style="width: 100%" v-model="model[ col.name ]" @change="val => col.onChange && col.onChange(self, val)" v-bind="{ ...col.elProps }">
              <el-option
                v-for="selectItem in col.children"
                :key="selectItem.value"
                :label="selectItem.name"
                :value="selectItem.value">
              </el-option>
            </el-select>
            <p class="tip" v-if="col.tip">{{ col.tip }}</p>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <slot></slot>
  </div>
</template>

<style scoped>
.tip {
  padding-top: 8px;
  line-height: 14px;
  color: #999;
  font-size: 12px;
}
.link {
  position: absolute;
  right: 0;
  top: -28px;
}
.form-data {
  background: #fff;
  /*padding: 24px;*/
  border-radius: 2px;
}
.col ~ .col {
  margin-left: 80px;
}
.radio-group {
  width: 300px;
  height: 40px;
  line-height: 22px;
  padding: 9px 24px;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
}
</style>

<script>
import { getModelToOption, getRulesToOption } from '@/utils/env';

export default {
  name: 'UiFormData',

  props: {
    isInline: {
      type: Boolean,
      default: () => false
    },
    labelPosition: {
      type: String,
      default: 'top'
    },
    buildFields: {
      type: Array,
      required: true
    },
    data: Object,
    labelWidth: String
  },

  data() {
    let model;
    if (this.data) {
      model = Object.keys(getModelToOption(this.buildFields)).reduce((memo, curr) => {
        memo[ curr ] = this.data[ curr ];
        return memo;
      }, {});
    } else {
      model = getModelToOption(this.buildFields);
    }
    return {
      self: this,
      model,
      rules: getRulesToOption(this.buildFields)
    };
  },

  watch: {
    'data'(data) {
      const actual = Object.keys(getModelToOption(this.buildFields)).reduce((memo, curr) => {
        memo[ curr ] = data[ curr ];
        return memo;
      }, {});
      this.model = { ...this.model, ...actual };
      this.$nextTick(() => this.$refs.form.clearValidate());
    },
    'buildFields'(fields) {
      this.model = Object.keys(getModelToOption(fields)).reduce((memo, curr) => {
        memo[ curr ] = this.model[ curr ];
        return memo;
      }, {});
      this.rules = getRulesToOption(fields);
      this.$nextTick(() => this.$refs.form.clearValidate());
    }
  },

  methods: {
    reset() {
      this.model = getModelToOption(this.buildFields);
      this.$nextTick(() => this.$refs.form.clearValidate());
    },
    validate() {
      let result = false;
      this.$refs.form.validate(valid => {
        result = valid;
      });
      return result;
    }
  },

  mounted() {
    this.$nextTick(() => this.$refs.form.clearValidate());
  }
};
</script>
